import { render, staticRenderFns } from "./CartOrderTable.vue?vue&type=template&id=afefae5c&"
import script from "./CartOrderTable.vue?vue&type=script&lang=js&"
export * from "./CartOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderTable.vue?vue&type=style&index=0&id=afefae5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports